export default __webpack_public_path__ + "static/media/Extrangeroblc.a4e07574.svg";